export const TYPES = [
  {
    name: 'Day',
    value: 'Day'
  },
  {
    name: 'Month',
    value: 'Month'
  },
]

export const DEFAULT_VALUE = {
  value: ['1', '30'],
  type: TYPES[0].value
}

export const DEFAULT_VALUE_MONTH = {
  value: ['1', '6'],
  type: TYPES[1].value
}